import { SchemaFields } from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { Provider } from "@redotech/redo-order-common/provider";
import { CompensationMethod } from "@redotech/redo-return-core-common/compensation-method";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";

/**
 * Fields whose meaning does not vary by schema — spread them rather than
 * restating, so the wording a merchant reads changes in exactly one place.
 */

export const redoCustomerIdFields = {
  redoCustomerId: {
    dataType: "Text",
    documentation:
      "Redo's own identifier for the customer, which is not the customer ID in your store platform.",
    hideFromInsertionModal: true,
    hideFromConditionStep: true,
  },
} as const satisfies SchemaFields;

export const unsubscribeLinkFields = {
  unsubscribeLink: {
    dataType: "Maybe Url",
    documentation:
      "A link for the customer to unsubscribe. Only appears when they are subscribed.",
  },
} as const satisfies SchemaFields;

export const oneClickUnsubscribeLinkFields = {
  oneClickUnsubscribeLink: {
    dataType: "Maybe Url",
    documentation: "A one-click unsubscribe link required by email providers.",
    hideFromInsertionModal: true,
  },
} as const satisfies SchemaFields;

export const returnIdFields = {
  returnId: {
    dataType: "Text",
    documentation: "The unique identifier for the return in Redo.",
    hideFromConditionStep: true,
    hideFromInsertionModal: true,
  },
} as const satisfies SchemaFields;

export const compensationMethodFields = {
  compensationMethod: {
    dataType: "Multiple Enum",
    documentation: "The method of compensation for the return.",
    values: Object.values(CompensationMethod),
  },
} as const satisfies SchemaFields;

export const customerRequestTypeFields = {
  customerRequestType: {
    dataType: "Enum",
    documentation:
      "What the customer asked for: a return, claim, warranty, recycle, or withdrawal.",
    values: Object.values(ReturnTypeEnum),
  },
} as const satisfies SchemaFields;

export const returnTagsFields = {
  returnTags: {
    dataType: "Multiple Text",
    documentation: "Tags associated with the return.",
  },
} as const satisfies SchemaFields;

export const returnTotalValueFields = {
  returnTotalValue: {
    dataType: "Text",
    documentation:
      "The total value of the return including taxes and adjustments, such as $100.00.",
  },
} as const satisfies SchemaFields;

export const returnProviderFields = {
  provider: {
    dataType: "Enum",
    documentation:
      "The ecommerce provider for this return (e.g., shopify, commentsold, bigcommerce).",
    values: Object.values(Provider),
  },
} as const satisfies SchemaFields;
